module.exports = require("@mui/material/InputAdornment");